// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__PgcIE","logoTitle":"style__logoTitle__vprnj"};